import { create } from 'zustand'

interface OnboardingStore {
  isOnboardingOpen: boolean
  setIsOnboardingOpen: (isOpen: boolean) => void
}

export const useOnboardingStore = create<OnboardingStore>((set) => ({
  isOnboardingOpen: false,
  setIsOnboardingOpen: (isOpen: boolean) => set({ isOnboardingOpen: isOpen }),
}))
